import React, { useState } from "react";
import NavItem from "./NavItem";
import ToggleDarkTheme from "./ToggleDarkTheme";

function LinksContainer({ active }) {
  const [isActive, setActiveLink] = useState(active);

  const setActiveIndex = (index) => {
    setActiveLink(index);
  };

  const navContent = [
    {
      Landing: "#",
      className: "nav-link fw-medium special-hover-color",
      ariaCurrent: "page",
      children: "Home",
    },
    {
      Landing: "#about",
      className: "nav-link special-hover-color",
      ariaCurrent: "page",
      children: "About Me",
    },
    {
      Landing: "#project",
      className: "nav-link special-hover-color",
      ariaCurrent: "page",
      children: "My Projects",
    },
    {
      Landing: "#contact",
      className: "nav-link special-hover-color",
      ariaCurrent: "page",
      children: "Contact Me",
    },
    {
      Landing: "",
      className: "",
      ariaCurrent: "page",
      children: <ToggleDarkTheme />,
    },
  ];
  return (
    <ul className="navbar-nav gap-3">
      {navContent.map((navLink, index) => (
        <NavItem
          key={index}
          Landing={navLink.Landing}
          className={
            isActive === index
              ? `${navLink.className} active`
              : navLink.className
          }
          aria-current={navLink.ariaCurrent}
          index={index}
          setActiveIndex={setActiveIndex}
        >
          {navLink.children}
        </NavItem>
      ))}
    </ul>
  );
}

export default LinksContainer;
